import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  private audio: HTMLAudioElement;
  private audioInterval: NodeJS.Timer;

  playAudio(): void {
    if (!this.audio) {
      this.audio = new Audio();
      this.audio.src = '../assets/audio/alarm.wav';
      this.audio.load();
    }

    if (this.audioInterval) {
      // audio is working already
      return
    } else {
      this.audioInterval = setInterval(() => {
        this.audio.play();
        console.log("play", new Date());
      }, 5000);
    }
  }

  stopAudio(): void {
    clearInterval(this.audioInterval);
  }
}
